<template>
  <v-dialog
    v-model="dialog"
    dark
    content-class="main-dialog"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-cellphone-key
      </v-icon> Check-In As
    </h2>
    <v-container fluid>
      <h2 class="subtitle-style">
        Please select your Check-In type
      </h2>
      <div class="pa-4 text-center">
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <template v-for="(item, i) in checkInTypes">
            <v-col
              :key="i"
              cols="6"
              sm="2"
              md="2"
            >
              <v-card
                id="type-card"
                light
                @click="toCheckIn(item)"
              >
                <div>
                  <v-avatar :style="{ 'background-color': colors[i]}">
                    <v-icon dark>
                      mdi-account-circle
                    </v-icon>
                  </v-avatar>
                  <p class="type-name">
                    {{ item }}
                  </p>
                </div>
              </v-card>
            </v-col>
          </template>
        </v-row>
      </div>
      <br>
    </v-container>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
  export default {
    name: 'CheckInTypeSelection',
    components: {
      'centre-spinner': spinner,
    },
    props: {
    scannedCode: {
      type: String,
      required: true,
    },
  },
    data () {
      return {
        dialog: true,
        colors: [
          '#C62828',
          '#37474F',
          '#1B91F7',
        ],
        loading: false,
      };
    },
    computed: {
      userDetails () {
        return this.$store.getters.getUser;
      },
      checkInTypes () {
        return this.userDetails.service_provider.type;
      },
    },
    watch: {
      dialog: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      toCheckIn (type) {
        this.loading = true;
        setTimeout(() => {
          this.toCheckInProcess(type);
        }, 2000);
      },
      toCheckInProcess (type) {
        this.loading = false;
        this.$router.push(`${this.scannedCode}/check-in/${type}`);
      },
    },
  };
</script>
<style>
.main-dialog {
  background-color: white !important;
}
</style>
<style scoped>
#type-card {
  border-left: 3px solid #546E7A !important;
  border-right: 3px solid #546E7A !important;
  border-top: 3px solid #546E7A !important;
  padding-top: 10px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.subtitle-style {
  color: #546E7A;
  font-family: 'Times New Roman', Times, serif;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.type-name {
  font-size: 18px;
  font-weight: bold;
  color: #263238;
  font-family: 'Times New Roman', Times, serif;
  text-transform: capitalize;
}
</style>
